import { render, staticRenderFns } from "./IconApplePay.vue?vue&type=template&id=735c7366&"
import script from "./IconApplePay.vue?vue&type=script&lang=js&"
export * from "./IconApplePay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports